/*******************************************************************************

Copyright (c) 2017-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*******************************************************************************/

// @format
// Map Api


import { ajax } from "./../core/highcharts-editor";
import config from "./../meta/highed.meta.map.config";

export default function() {

  ///////////////////////////////////////////////////////////////////////////

  function getLatLong(location, cb) {
    if (!config) return;

    let request_url = config.url
    + '?'
    + 'key=' + config.api_key
    + '&q=' + encodeURIComponent(location)
    + '&format=json';

    ajax({
      url: request_url,
      success: function(request){
        let latKey = config.latKey || 'lat';
        let longKey = config.longKey || 'lon';
        let nameKey = config.nameKey || 'display_name';

        if (request && request.length > 0) {
          cb(
            request.map(function(r,i){
              return {
                lat: r[latKey], 
                lon: r[longKey],
                value: r[nameKey],
                name: i
              }
            }));
        } else {
          alert("We are unable to find any results that match the search query.");
          cb(false);
        }
      },
      error: function(err) {
        
      },
      skipContentType: true
    });

  }

  return {
    getLatLong: getLatLong
  };

};